<div class="modal-header">
  <h5 class="modal-title">Change Main Topic Name</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="row mb-1 align-items-center">
      <label class="col-4 col-form-label">Exam Agency</label>
      <div class="col-6">
        <input formControlName="examAgency" class="form-control input-grey" />
      </div>
    </div>

    <div class="row mb-1 align-items-center">
      <label class="col-4 col-form-label">Course Name</label>
      <div class="col-6">
        <input formControlName="course" class="form-control input-grey" />
      </div>
    </div>

    <div class="row mb-1 align-items-center">
      <label class="col-4 col-form-label">Year</label>
      <div class="col-3">
        <input formControlName="year" class="form-control input-grey" />
      </div>
    </div>

    <div class="row mb-1 align-items-center">
      <label class="col-4 col-form-label">Course Main Topic</label>
      <div class="col-6">
        <input
          formControlName="courseMainTopic"
          class="form-control input-blue"
        />
      </div>
    </div>

    <div class="row mb-1 align-items-center">
      <label class="col-4 col-form-label">Status</label>

      <div class="col-3">
        <select formControlName="status" class="form-select input-blue">
          <option *ngFor="let item of mainTopicstatusTypeCode" [value]="item.Code">
            {{ item.Description }}
          </option>
        </select>
      </div>
    </div>


    <div class="row mb-1 align-items-center">
      <label class="col-4 col-form-label">Display order</label>
      <div class="col-2">
        <input
          type="number"
          formControlName="displayOrder"
          class="form-control input-blue"
        />
      </div>
    </div>
  </form>
</div>

<div class="modal-footer justify-content-between">
  <button type="button" (click)="save()" class="btn btn-blue w-45">Save</button>
  <button type="button" (click)="cancel()" class="btn btn-outline-blue w-45">
    Cancel
  </button>
</div>
